import BackgroundText from "../common/BackgroundText";
import ImageTitleWithDescription from "../common/ImageTitleWithDescription";
import GlowEffect from "../common/GlowEffect";
import { useNavigate } from "react-router-dom";
import { useInsightsData } from "../../hooks/useInsightsData";

export default function NewsSection() {
  const navigate = useNavigate();
  const { data } = useInsightsData();
  
  const handleKnowMore = (id: string) => {
    navigate(`/insights/news/${id}`);
  };

  return (
    <div className="py-10 md:py-20 relative">
      <GlowEffect />
      <div className="container mx-auto px-5 sm:px-10 relative z-10">
        <BackgroundText text="News" />
        <ImageTitleWithDescription data={data.newsPosts} handleKnowMore={handleKnowMore} />
      </div>
    </div>
  );
}
